import type { ReactNode } from "react";
import { Body2, SelectionCard, Subtitle1, Title4, YStack } from "@medbillai/ui";
export type LandingCardOption = {
  id: string;
  label: string;
  testID?: string;
  onPress: () => void;
};

/** A question inside the landing card; the hero carries the page's voice, so quieter chrome than `OnboardingScreen`. */
export function LandingCardQuestion({
  title,
  titleTestID,
  subtitle,
  options,
  optionsTestID,
  children
}: {
  title: string;
  titleTestID?: string;
  subtitle?: string;
  /** The answers to the question. `children` covers anything that isn't a list of answers. */
  options?: readonly LandingCardOption[];
  optionsTestID?: string;
  children?: ReactNode;
}) {
  return <YStack gap="$sp3" data-sentry-element="YStack" data-sentry-component="LandingCardQuestion" data-sentry-source-file="LandingCardQuestion.tsx">
      <YStack gap="$sp0.5" data-sentry-element="YStack" data-sentry-source-file="LandingCardQuestion.tsx">
        <Title4 textAlign="center" testID={titleTestID} data-sentry-element="Title4" data-sentry-source-file="LandingCardQuestion.tsx">
          {title}
        </Title4>
        {subtitle ? <Body2 color="$textSubtle" textAlign="center">
            {subtitle}
          </Body2> : null}
      </YStack>
      {options === undefined ? null : <YStack gap="$sp1.5" testID={optionsTestID}>
          {options.map(({
        id,
        label,
        testID,
        onPress
      }) => <SelectionCard key={id} kind="button" tone="brand" onPress={onPress} height="$si6" paddingVertical={0} borderRadius="$brFull" justifyContent="center" {...testID !== undefined ? {
        testID
      } : {}}>
              <Subtitle1 textAlign="center">{label}</Subtitle1>
            </SelectionCard>)}
        </YStack>}
      {children}
    </YStack>;
}